import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const Wrapper = styled(Box)(`
    // border: 1px red solid;
`)

export const ComponentWrapper = styled(Box)(`
    color: rgb(17, 24, 39);
    background-color: rgb(246, 247, 248, 0.7);
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1);
    padding: 32px;
    border-radius: 12px;
    border: 1px dashed rgb(229, 231, 235) initial;
    margin-bottom:20px;
`)
